import React from 'react';
import { useEauConversation, type EauKind } from '../../hooks/useEauConversation';
import { AtnaDialogShell } from '../atna/AtnaDialogShell';
import { EauMessage } from './EauMessage';
interface EauDialogProps {
  initialText: string;
  onClose: () => void;
  /** Shared layout id: the launcher pill morphs into this panel. */
  layoutId: string;
  onConfigureAlerts: () => void;
  onPay: () => void;
}
export function EauDialog({
  initialText,
  onClose,
  layoutId,
  onConfigureAlerts,
  onPay
}: EauDialogProps) {
  const {
    turns,
    thinking,
    draft,
    setDraft,
    submitDraft,
    acknowledge,
    liveAtnaId
  } = useEauConversation(initialText);
  const configure = () => {
    acknowledge('Ouvrir mes alertes de consommation');
    onConfigureAlerts();
    onClose();
  };
  const pay = () => {
    acknowledge('Payer ma facture d’eau');
    onPay();
    onClose();
  };
  return <AtnaDialogShell layoutId={layoutId} subtitle="Compteur d’eau" onClose={onClose} turns={turns} thinking={thinking} liveAtnaId={liveAtnaId} footnote="ATNA peut se tromper. Les lectures officielles font foi sur votre facture d’eau." prompt={{
    value: draft,
    onChange: setDraft,
    onSubmit: submitDraft,
    placeholder: 'Poser une question sur votre consommation…'
  }} renderAtna={(kind, live) => <EauMessage kind={kind as EauKind} live={live} onConfigureAlerts={configure} onPay={pay} data-id="element-1208" data-mp="7xttnh1qabvz" />} data-id="element-1207" data-mp="1d7xb4e6x3e90" />;
}